import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FormContainer } from "../../components/Form/FormComponents.styled";
import { fetchLogObject } from "./utils";
import PurchasedForm from "./sections/PurchasedForm";
import MaintainedForm from "./sections/MaintainedForm";
import DeployedForm from "./sections/DeployedForm";
import InspectedForm from "./sections/InspectedForm";
import RetainedForm from "./sections/RetainedForm";
import RepairedForm from "./sections/RepairedForm";
import AwaitingForm from "./sections/AwaitingForm";
import RetrievedForm from "./sections/RetrievedForm";
import ReassignedForm from "./sections/ReassignedForm";
import SoldForm from "./sections/SoldForm";
import AwaitingProcure from "./sections/AwaitingProcure";

/* eslint-disable no-unused-vars */
const SingleLogistics = () => {
	let { category, id: requestId, filter } = useParams();
	const [loading, setLoading] = useOutletContext();
	const [requestData, setRequestData] = useState(null);

	const getCurrentObject = async () => {
		const data = await fetchLogObject(requestId, filter);
		// Handle response data
		// console.log(requestId, filter);
		console.log("data:", data);
		if (data && !data?.error) {
			setLoading(false);
			setRequestData(data.result);
		} else {
			setLoading(false);
			setRequestData(data);
			toast.error(data?.error || "Error fetching data!");
		}
	};

	useEffect(() => {
		setLoading(true);
		getCurrentObject();
	}, []);

	const CurrentPageForm = (props) => {
		const newSections = ["reassigned_assets", "sold_assets"];

		if (category === "awaiting_purchase") {
			return <AwaitingForm {...props} />;
		} else if (category === "procured_assets") {
			return <PurchasedForm {...props} />;
		} else if (category === "awaiting_procurement") {
			return <AwaitingProcure {...props} />;
		} else if (category === "deployed_assets") {
			return <DeployedForm {...props} />;
		} else if (category === "maintained_assets") {
			return <MaintainedForm {...props} />;
		} else if (category === "inspected_assets") {
			return <InspectedForm {...props} />;
		} else if (category === "retained_assets") {
			return <RetainedForm {...props} />;
		} else if (category === "repaired_assets") {
			return <RepairedForm {...props} />;
		} else if (category === "retrieved_assets") {
			return <RetrievedForm {...props} />;
		} else if (category === "sold_assets") {
			return <SoldForm {...props} />;
		} else if (newSections.includes(category)) {
			return <ReassignedForm {...props} />;
		} else {
			return <div className='text-center p-3'>[404] Error: Category not found!</div>;
		}
	};

	return (
		<FormContainer>
			{
				// Show CurrentPageForm if requestId is present and loading is false
				requestData?.objectId && !loading ? (
					<CurrentPageForm requestData={requestData} setRequestData={setRequestData} filter={filter} />
				) : requestData?.error ? (
					<div className='text-center fw-500 p-3'>Error fetching data!</div>
				) : null
			}
		</FormContainer>
	);
};

export default SingleLogistics;
